import React from 'react';
import { Container } from './styles';

export function ButtonContainer({ children, position }) {
  return <Container position={position}>{children}</Container>;
}
